import React from 'react';

const Comp3 = (props) => {
    return (
        <div class="sec">
            <h1 class="head head_3">3</h1>
            <div class="sec_3"></div>
        </div>
    )
}

export default Comp3;